import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-311c9f22")

_pushScopeId("data-v-311c9f22")
const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "px-4 space-y-6" }
const _hoisted_3 = { class: "my-2" }
const _hoisted_4 = { class: "flex flex-row gap-x-2 lp-checkbox p-field-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "checkbox-forward-commission-detail-shipment-label" }, "Shipment", -1)
const _hoisted_6 = { class: "grid grid-cols-4 gap-4 py-3 pl-8" }
const _hoisted_7 = { class: "flex flex-row gap-x-2 lp-checkbox p-field-checkbox py-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "checkbox-forward-commission-detail-shipment-label" }, "Retail", -1)
const _hoisted_9 = { class: "flex flex-row gap-x-2 lp-checkbox p-field-checkbox py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "checkbox-forward-commission-detail-shipment-label" }, "Client", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "Digunakan untuk",
        class: "w-10/12"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Checkbox, {
                id: "checkbox-forward-commission-detail-shipment-label",
                disabled: true,
                name: "commission-applied-to-label",
                value: "shipment",
                modelValue: _ctx.commissionAppliedTo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.commissionAppliedTo = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableShipmentPrefix, (option, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: option,
                  class: ["gap-x-2 flex flex-row lp-checkbox p-field-checkbox", `${index > 13 && index % 3 === 2 && 'col-span-2'}`]
                }, [
                  _createVNode(_component_Checkbox, {
                    id: `checkbox-forward-commission-detail-${option}`,
                    disabled: true,
                    name: "commission-applied-to",
                    value: option,
                    modelValue: _ctx.commissionAppliedTo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.commissionAppliedTo = $event))
                  }, null, 8, ["id", "value", "modelValue"]),
                  _createVNode("label", {
                    for: `checkbox-forward-commission-detail-${option}`
                  }, _toDisplayString(option), 9, ["for"])
                ], 2))
              }), 128))
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Checkbox, {
                id: "checkbox-forward-commission-detail-retail-label",
                disabled: true,
                name: "commission-applied-to-label",
                value: "retail",
                modelValue: _ctx.commissionAppliedTo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.commissionAppliedTo = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_8
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_Checkbox, {
                id: "checkbox-forward-commission-detail-client-label",
                disabled: true,
                name: "commission-applied-to-label",
                value: "client",
                modelValue: _ctx.commissionAppliedTo,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.commissionAppliedTo = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_10
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
})